import { render } from "./ExamGridList.vue?vue&type=template&id=8090be38&scoped=true"
import script from "./ExamGridList.vue?vue&type=script&lang=js"
export * from "./ExamGridList.vue?vue&type=script&lang=js"

import "./ExamGridList.vue?vue&type=style&index=0&id=8090be38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8090be38"]])

export default __exports__